import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { SubjectBillingItem } from '../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../shared/models/payment.model';
import { InvoicePayment } from '../../../shared/models/invoicePayment.model';
import { SystemFile } from 'src/app/shared/models/file.model';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-work-order-log-widget',
  templateUrl: './work-order-log-widget.component.html',
  styleUrls: ['./work-order-log-widget.component.css']
})
export class WorkOrderLogWidgetComponent implements OnInit {


  
  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;

  @Input() invoice_id?; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  @Input() work_order_id?; // impliments on changes.
  @Input() work_order_number?; // impliments on changes.
  @Input() agent_id?; // impliments on changes.

  
  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
  @Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();

  @Output('pushInvoiceFileToSend') pushInvoiceFileToSend: EventEmitter<any> = new EventEmitter();
  @Input() show_attach_button: false;

  paymentModel: Payment;
  invoicePaymentModel: InvoicePayment;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  invoice_payment: any;
  invoice_files: Object;

  fileModel = SystemFile;
  invoice_logs: Object;
  logModel = SystemLog;
  work_order_logs: any;

  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) {
 
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
 
  // this.toastr.setRootViewContainerRef(vcr);
 
   }
 
   // check for changes. to load data.
   ngOnChanges(changes) {
 
    // if (changes.agent_id) {
      
    //   // deal with asynchronous Observable result
    //   this.agent_id = changes.agent_id.currentValue;
    //   // this.getSubjectInvoiceFiles(this.invoice_id);
    //   // this.getInvoiceLogs(this.invoice_id);
    //   this.getWorkAgentOrderLogs(this.work_order_id, this.agent_id);
 
    // }

    if (changes.work_order_id) {
      
      // deal with asynchronous Observable result
      this.work_order_id = changes.work_order_id.currentValue;
      // this.getSubjectInvoiceFiles(this.invoice_id);
      // this.getInvoiceLogs(this.invoice_id);
      this.getWorkAgentOrderLogs(this.work_order_id, this.agent_id);
 
    }

  }
 
 
  ngOnInit() {
   // this.getInvoice(this.invoice_id);
   // this.getMyobAccountCodes();
  //  this.getWorkAgentOrderLogs(this.work_order_id, this.agent_id);
  }



  getInvoicePayments(invoice_id){
    this._demoService.getInvoicePayments(invoice_id).subscribe(
      (data) => {
        this.invoice_payment = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getSubjectInvoiceFiles(invoice_id){
    this._demoService.getSubjectInvoiceFiles(invoice_id).subscribe(
      (data) => {
        this.invoice_files = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


// // Loads from add new billing items modal.
// refreshInvoiceItemsBelow() {
//   console.log('Reloading Items');
//   this.getInvoiceItmes(this.invoice_id);
// }


private getInvoiceLogs(invoice_id) {
  this._demoService.getInvoiceLogs(invoice_id).subscribe(
    (res) => (this.invoice_logs = res),
    (err) => console.error(err.status)
  );
} /* */

private getWorkAgentOrderLogs(work_order_id, agent_id) {
  this._demoService.getAgentWorkOrderLogs(work_order_id, agent_id).subscribe(
    (res) => (this.work_order_logs = res,
      console.log('LOG WO: ' + JSON.stringify(this.work_order_logs))
      ),
    (err) => (
      // console.error(err.status),
      console.log(err)
      ),
  );
} /* */






}